import React from "react";
import { Image } from "semantic-ui-react";
import classNames from "classnames";
import { map } from "lodash";
import { formatElapsed } from "../../../utils/date";
import { useNow } from "../../../hooks";
import {
  getClockOffsetMs,
  getPollingStats,
  isClockDebug,
} from "../../../utils/serverClock";
import { ORDER_STATUS } from "../../../utils/constants";
import "./OrderHistoryItem.scss";

const STATUS_LABEL = {
  [ORDER_STATUS.PENDING]: "En marcha",
  [ORDER_STATUS.READY]: "¡Listo! Ya te lo llevan",
  [ORDER_STATUS.DELIVERED]: "Entregado",
};

export function OrderHistoryItem(props) {
  const { order } = props;
  const { title, image } = order.product_data;
  const now = useNow();

  return (
    <div
      className={classNames("order-history-item", {
        [order.status.toLowerCase()]: true,
      })}
    >
      {/* Solo mientras está en marcha: entregado ya no necesita contador. */}
      {order.status === ORDER_STATUS.PENDING && (
        <div className="order-history-item__time">
          <span>Pedido {formatElapsed(order.created_at, now)}</span>
          {/* Diagnóstico del contador, solo con ?debug=1 en la URL. */}
          {isClockDebug() && (
            <small style={{ display: "block", fontSize: "0.65rem", lineHeight: 1.3 }}>
              pedido: {String(order.created_at)}
              <br />
              celular: {new Date().toISOString()}
              <br />
              ahora usado: {new Date(now).toISOString()} · ajuste:{" "}
              {Math.round(getClockOffsetMs() / 1000)} s
              <br />
              visible: {document.visibilityState} · timer: {getPollingStats().timer}{" "}
              (último{" "}
              {getPollingStats().lastTimerAt
                ? getPollingStats().lastTimerAt.toLocaleTimeString()
                : "nunca"}
              ) · toques: {getPollingStats().touch} · al volver:{" "}
              {getPollingStats().resume}
            </small>
          )}
        </div>
      )}

      <div className="order-history-item__product">
        {image && <Image src={image} />}
        <div>
          <p>{title}</p>
          {order.offer_data && (
            <p className="order-history-item__offer">
              🎁 {order.offer_data.title}
            </p>
          )}
          {order.takeaway && <p className="order-history-item__note">🥡 Para llevar</p>}
          {order.is_courtesy && (
            <p className="order-history-item__offer">Cortesía de la casa</p>
          )}
          {order.option_choice && (
            <p className="order-history-item__note">{order.option_choice}</p>
          )}
          {map(order.extras, (extra) => (
            <p className="order-history-item__extra" key={extra.id}>
              + {extra.label} x{extra.quantity}
            </p>
          ))}
          {order.note && (
            <p className="order-history-item__note">Nota: {order.note}</p>
          )}
        </div>
      </div>

      <span>{STATUS_LABEL[order.status] || "En marcha"}</span>
    </div>
  );
}
